// extracted by mini-css-extract-plugin
export var btn = "Button-module--btn--e4927";
export var link = "Button-module--link--c7764";
export var orange = "Button-module--orange--8f0d1";
export var primary = "Button-module--primary--2e17d";
export var rebrandAction = "Button-module--rebrandAction--1b4c7";
export var reskin = "Button-module--reskin--159b7";
export var secondary = "Button-module--secondary--e788d";
export var secondaryReverse = "Button-module--secondary-reverse--7ebc7";
export var sm = "Button-module--sm--bf91e";
export var tertiary = "Button-module--tertiary--c503d";
export var xs = "Button-module--xs--23d7f";